export const translator = state => key => {
    return state.translations[key]
        ? state.translations[key]
        : key;
};
